// extracted by mini-css-extract-plugin
export default {"container":"Success_container__w0HZm","img":"Success_img__zQCMq"};